import React from 'react'

export const LoadingContext = React.createContext({
    isLoad: false,
    setIsLoad: () => { },
    isLoadingRef: { current: false },
    // isOpenToast: false,
    // setIsOpenToast: () => { },
    // alertMessage: '',
    // setAlertMessage: () => { },
    // colorSnack: '',
    // setColorSnack: () => { },
    // alertFunction: '',
    // setAlertFunction: () => { },
    passValues: '',
    setPassValues: () => { },
    DEFAULTURL: '',
    toastMessages: () => { },
    useComma: true,
    setUseComma: () => { },
    primaryColor: '',
    secondaryColor: '',
    tertiaryColor: '',
    passValue: new Map(),
    setPassValue: () => { }
})